export default "__VITE_ASSET__333f878a__"